import { ColorThemeOption } from '../../messaging/ColorLibrary';
import { BlobKey } from './BlobKey';
export const BlobConfig = {
  [BlobKey.ImageBlob]: {
    configColorThemeOption: ColorThemeOption.YellowLight
  },
  [BlobKey.AnimationBlob]: {
    configColorThemeOption: ColorThemeOption.YellowLight
  }
};
export const DEFAULT_MESSAGING = {};